import React, { FC } from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';
import { orderGroupDistribution } from '../../../../helpers/helpers';
import {
  IIndividualStatesTopicsData,
  IWorkEnvironmentCategoryData,
} from '../../../../services/individualReport';
import SummaryCard from '../SummaryCard/SummaryCard';

const styles = StyleSheet.create({
  list: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 8,
    overflow: 'hidden',
  },
});

interface ISummaryCategoriesList {
  data: IWorkEnvironmentCategoryData[];
  mode: 'results' | 'group';
  type: 'categories';
}

interface ISummaryTopicsList {
  data: IIndividualStatesTopicsData[];
  mode: 'results' | 'group';
  type: 'topics';
}

type ISummaryList = ISummaryCategoriesList | ISummaryTopicsList;

const SummaryList: FC<ISummaryList> = ({ data, mode, type }) => (
  <View style={styles.list}>
    {type === 'categories'
      ? data.map(({ category, group_distribution, score, score_rating }, index) => {
          const { code, title } = category;

          return (
            <SummaryCard
              key={code}
              distribution={orderGroupDistribution(group_distribution)}
              hasBorder={index < data.length - 1}
              {...{ mode, score, score_rating, title, code }}
            />
          );
        })
      : null}
    {type === 'topics'
      ? data.map(({ group_distribution, score, score_rating, topic }, index) => {
          const { code, title } = topic;

          return (
            <SummaryCard
              key={code}
              distribution={orderGroupDistribution(group_distribution)}
              hasBorder={index < data.length - 1}
              {...{ mode, score, score_rating, title, code }}
            />
          );
        })
      : null}
  </View>
);

export default SummaryList;
